__webpack_require__.p = "/payments-lg-propiedades/";